/**
 * Utility functions for post deletion logic
 */

// Determine if a post can be deleted (enabled for all statuses except publish_pending and delete_pending)
export const canDelete = (post) => {
  if (!post || !post.status) return false;
  return !['publish_pending', 'delete_pending'].includes(post.status);
};

// Get the appropriate delete confirmation message based on post status
export const getDeleteConfirmationMessage = (post) => {
  if (!post || !post.status) return 'Are you sure you want to delete this post?';
  
  const permanentDeleteStatuses = ['publish_failed', 'deleted', 'delete_failed'];
  if (permanentDeleteStatuses.includes(post.status)) {
    return `WARNING: This post is in "${post.status}" status and will be PERMANENTLY DELETED. This action cannot be undone. Are you sure you want to proceed?`;
  }
  
  return 'Are you sure you want to delete this post?';
};

// Show delete confirmation dialog with appropriate message
export const showDeleteConfirmation = (post) => {
  const message = getDeleteConfirmationMessage(post);
  return window.confirm(message);
};
